/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { BiTransfer } from 'react-icons/bi';
import { MdEmail, MdPhoneInTalk } from 'react-icons/md';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
// import { GoMail } from 'react-icons/go';
import { useTranslation } from 'react-i18next';
import { BiFullscreen } from 'react-icons/bi';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { FaCrown } from 'react-icons/fa';
import { IoLogoWhatsapp } from 'react-icons/io';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { imageUrl } from '../../config/apiUrl';
import { Area, Bath, building, Grounds, mapPin, Rooms } from '../../constant/imagePath';
import { useFavoriteEntityMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';
import { m2ToFt2, usdToOther } from '../../utils/helpers';
import Tooltip from '../Tooltip';
import classes from './PropertyHorizontalCard.module.css';
import { TiStarFullOutline } from 'react-icons/ti';
import bathIcon from '../../../src/assets/images/bath.png';
import fullScreen from '../../../src/assets/images/fullScreen.png';
import upGrid from '../../../src/assets/images/upGrid.png';
import sofa from '../../../src/assets/images/sofa.png';
import buildingIcon from '../../../src/assets/images/building.png';

const PropertyHorizontalCard = ({
  data,
  index,
  className = '',
  onEmailClick = () => null,
  refetch
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('webCommon');
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { areaUnit, currency } = useSelector((state) => state.converterReducer);
  const navigate = useNavigate();
  const [isFavorite, setIsFavorite] = useState(data?.favoriteBy?.includes(user?._id));
  const [isMobile, setIsMobile] = useState(false);

  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();
  const [postApiFunc] = usePostApiMutation();

  const handleCompare = async (data) => {
    const onlyCompareProperty = user?.compareList?.filter((item) => item?.type == 'Property');
    const ifAlreadyExist = onlyCompareProperty?.find((item) => item?.entity == data?._id);
    if (!ifAlreadyExist && onlyCompareProperty?.length >= 3)
      return toast.error(t('propertyCard.toast.error'));

    const response = await postApiFunc({
      url: `users/compare/add`,
      method: 'POST',
      tag: `compareListFront`,
      data: {
        id: data?._id,
        type: 'property'
      }
    });
    if (response?.data) {
      dispatch(updateUser(response?.data?.data));
      toast.success(
        `${t('propertyCard.property')} ${ifAlreadyExist ? t('propertyCard.toast.removedFrom') : t('propertyCard.toast.added')
        } ${t('propertyCard.toast.success')}`
      );
    }
  };

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: data?._id, type: 'property' });
    if (res?.data) {
      if (!res?.data?.data?.favoriteBy?.includes(user?._id)) {
        toast.success(t('propertyCard.toast.propertyRemoved'));
      } else {
        toast.success(t('propertyCard.toast.propertyAdded'));
      }
      setIsFavorite(res?.data?.data?.favoriteBy?.includes(user?._id));
    }
    // refetch && refetch();
  };

  const responsiveSettings = [
    { breakpoint: isMobile ? 700 : 465, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 200, settings: { slidesToShow: 1, slidesToScroll: 1 } }
  ];
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  const [isImageLoaded, setIsImageLoaded] = useState(false); // Track image load state

  // Handle image load event
  const handleImageLoad = () => {
    setIsImageLoaded(true); // Set image as loaded when the onLoad event fires
  };

  const characterLimit = (item, limit) => {
    let limit_ = limit || 61;
    if (item.length <= limit_) {
      return item;
    }
    let tmp = item.split('').splice(limit_, item.length - limit_, '...');
    tmp.splice(limit_, item.length - limit_, '...');
    return tmp.join('');
  };

  return (
    <>
      <style>
        {`


.react-slideshow-container .default-nav{
color:white !important;
background:none !important;
}


.react-slideshow-container .default-nav svg{
fill:white !important;
}

      .${classes.sliderContainer} .react-slideshow-container .default-nav{
     background:none !important;
        color:#FFFFFF !important;
        transition: 0.5s ease;
        opacity:0;
      }
      .${classes.sliderContainer} .react-slideshow-container .default-nav svg{
        fill:#FFFFFF !important;
      }
      .${classes.sliderContainer} .react-slideshow-container .default-nav:hover{
        background: transparent;
      }

      .${classes.sliderContainer}:hover .react-slideshow-container .default-nav{
        opacity:1;
      }
        a {
          text-decoration: none;
          color: inherit;
        }
          a:hover {
            text-decoration: none;
            color: inherit;
          }
      `}
      </style>

      <div className={[classes?.propertyMain, className].join(' ')}>
        {/* Slider */}
        <div className={classes?.sliderContainer}>
          <PhotoProvider>
            <Slide responsive={responsiveSettings}>
              {data?.images?.map((image, i) => (
                <div className={classes?.propertyImageContainer} key={i}>
                  <PhotoView src={image?.includes('https://') ? image : imageUrl(image)}>
                    <img
                      src={image?.includes('https://') ? image : imageUrl(image)}
                      alt={`property image ${i + 1}`}
                      className={`${classes?.propertyImage} ${classes?.lazyLoad} ${isImageLoaded ? classes?.loaded : ''
                        }`}
                      draggable={false}
                      onLoad={handleImageLoad}
                      loading="lazy" // Native lazy loading
                    />
                  </PhotoView>
                </div>
              ))}
            </Slide>
          </PhotoProvider>
          <div className={classes.iconWrapCustom}>
            <div className={classes.innerIconWrap}>
              <Tooltip text={t('propertyCard.tooltips.compare')} position="top">
                <div className={classes.iconBorder}>
                  <BiTransfer
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      if (!handleAction()) return;
                      handleCompare(data);
                    }}
                    className={classes.iconsBottom}
                    // size={30}
                    size={20}
                    fill={
                      user?.compareList?.find((e) => e?.entity == data?._id)
                        ? 'var(--action-icon-clr)'
                        : 'white'
                    }
                  />
                </div>
              </Tooltip>
              <Tooltip
                text={
                  isFavorite
                    ? t('propertyCard.tooltips.removeFavorite')
                    : t('propertyCard.tooltips.addFavorite')
                }
                position="top">
                {isFavorite ? (
                  <div className={classes.iconBorder}>
                    <AiFillHeart
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        handleFavorite();
                      }}
                      fill="var(--action-icon-clr)"
                      className={classes.iconsBottom}
                      size={20}
                    // size={30}
                    />
                  </div>
                ) : (
                  <div className={classes.iconBorder}>
                    <AiOutlineHeart
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        if (!handleAction()) return;
                        handleFavorite();
                      }}
                      fill="var(--text-light-gray-clr)"
                      className={classes.iconsBottom}
                      // size={30}
                      size={20}
                    />
                  </div>
                )}
              </Tooltip>
            </div>
          </div>
        </div>

        <Link to={`/property/${data?.slug ?? '1'}`} className={classes?.rightContainer}>
          <div className={classes.topSection}>
            {/* Price + Logo */}
            <div className={classes?.topContainer}>
              <div className={classes?.flexCol}>
                <p className={[classes.title, 'maxLine2'].join(' ')}>
                  {data?.title?.[selectedLanguage] ?? 'Countryside Modern Lake'}
                </p>
                <div className={classes?.location}>
                  <img src={mapPin} alt="location" />
                  <span className={[classes.address, 'p16'].join(' ')}>{data?.address}</span>
                </div>
              </div>

              <div
                className={classes?.logoContainer}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  navigate(`/company/${data?.company?.slug}`);
                }}>
                <img src={imageUrl(data?.company?.photo)} />
              </div>
            </div>
            <div className={classes.buildingIcon}>
              <Tooltip text={t('propertyCard.tooltips.propertyType')}>
                <img src={buildingIcon} alt="buildingIcon" />
              </Tooltip>
              <p>{data?.propertyType?.title?.[selectedLanguage]}</p>
            </div>
            {/* description */}
            {/* Property Info */}
            <div className={classes?.propertyInfoContainer}>
              <Tooltip text={t('propertyCard.tooltips.level')}>
                <div className={classes.iconContainer}>
                  <img src={upGrid} alt="upgrid" />
                  <p>{data?.floorLevel?.[selectedLanguage]}</p>
                </div>
              </Tooltip>
              <Tooltip text={t('propertyCard.tooltips.area') + ` (${areaUnit})`}>
                <div className={classes.iconContainer}>
                  <img src={fullScreen} alt="floor" />
                  <p>
                    {`${m2ToFt2({ area: data?.netArea, areaUnit, unit: false })}` + `${areaUnit}`}
                  </p>
                </div>
              </Tooltip>

              <Tooltip text={t('propertyCard.tooltips.bathrooms')}>
                <div className={classes.iconContainer}>
                  <img src={bathIcon} alt="bath" />
                  <p>{`${data?.noOfBathrooms}`}</p>
                </div>
              </Tooltip>
              <Tooltip text={t('propertyCard.tooltips.rooms')}>
                <div className={[classes.iconContainer, classes.lastIconContainer].join(' ')}>
                  <img src={sofa} alt="bath" />
                  <p>{`${data?.noOfRooms?.[selectedLanguage]}`}</p>
                </div>
              </Tooltip>
            </div>
          </div>
          {/* bottom strip */}
          <div className={classes?.bottomStrip}>
            <div className={classes.bottomSection}>
              <div className={classes.socialIconsWrap1}>
                <a
                  href={`tel:${data?.phoneNumber}`}
                  className={classes.socialIcons1}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}>
                  <Tooltip text={t('propertyCard.tooltips.call')}>
                    <MdPhoneInTalk fill="#00A997" className={classes.iconsBottom} />
                  </Tooltip>
                </a>
                <a
                  className={[classes.socialIcons1, classes.midIcon].join(' ')}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    onEmailClick && onEmailClick();
                  }}>
                  <Tooltip text={t('propertyCard.tooltips.email')}>
                    <MdEmail fill="#00A997" className={classes.iconsBottom} />
                  </Tooltip>
                </a>
                <a
                  href={`https://wa.me/${data?.whatsapp}`}
                  className={classes.socialIcons1}
                  target="_blank"
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}>
                  <Tooltip text={t('propertyCard.tooltips.whatsapp')}>
                    <IoLogoWhatsapp fill="#00A997" className={classes.iconsBottom} />
                  </Tooltip>
                </a>
              </div>

              {/* right */}
              <div className={classes?.priceContainer}>
                <span className={classes.currency}>
                  {usdToOther({ amount: data?.price, ...currency })}
                </span>
                {data?.propertyPurpose?.en == 'Rent' && (
                  <span className={classes.perMonth}>
                    {t('propertyCard.perMonth')}
                    {/* {data?.propertyPurpose?.en == 'Rent' ? data?.rentType?.[selectedLanguage] : ''} */}
                  </span>
                )}
              </div>
            </div>
          </div>
        </Link>

        {/* </div> */}

        <div className={classes?.featuredPremiumContainer}>
          <span
            className={`${(data?.isFeatured && classes?.featuredIco) || (data?.isPremium && classes?.premiumIco)
              }`}>
            {data?.isFeatured && <TiStarFullOutline size={16} />}
            {data?.isPremium && <FaCrown size={14} />}
            {(data?.isPremium && t('projectCard.premium')) ||
              (data?.isFeatured && t('projectCard.featured'))}
          </span>
        </div>
      </div>
    </>
  );
};

export default PropertyHorizontalCard;
